import type { SliceStateFromReducer } from 'shared/types';

import { createDescription } from '../lib/helpers';

import type { userScoreSlice } from './userScore.slice';

export type TUserScoreState = SliceStateFromReducer<typeof userScoreSlice>;

export const userScoreSelector = (state: TUserScoreState, lowLimit = 570, midLimit = 794) => {
  const { score } = state.userScore;
  return { score, description: createDescription({ score, lowLimit, midLimit }) };
};

export const getUserScoreSelector = (state: TUserScoreState) => state.userScore;
